import toNow from 'date-fns/formatDistanceToNow';
import { sk } from 'date-fns/locale';

export function formatTimeAgo(date: string) {
  try {
    return toNow(new Date(date), { locale: sk, addSuffix: true });
  } catch (error) {
    console.error(error);
    return '';
  }
}
